export const heroStats = [
  { id: "stat-1", value: "1,284", label: "已登记素材", unit: "段" },
  { id: "stat-2", value: "36.7", label: "逐帧标注", unit: "万帧" },
  { id: "stat-3", value: "912", label: "已复核疑点", unit: "条" },
  { id: "stat-4", value: "24h", label: "修订响应", unit: "" },
];

export const heroChips = [
  { id: "chip-1", label: "逐帧画面", href: "#dimensions" },
  { id: "chip-2", label: "声音识别", href: "#dimensions" },
  { id: "chip-3", label: "背景信息疑点", href: "#suspicions" },
];

export type InsightItem = {
  id: string;
  title: string;
  category: string;
  analysisType: string;
  summary: string;
  cover: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  confidence: string;
};

export const featuredInsight: InsightItem = {
  id: "featured-01",
  title: "「会议门」现场收音比对：唇形与声纹的三处错位",
  category: "声音识别",
  analysisType: "声纹比对",
  summary:
    "把争议段落的原始音轨分离成人声与环境两层后，逐帧对照唇形开合。第 42 秒、1 分 09 秒、2 分 31 秒三处出现口型与声纹不同步，其中两处可被环境噪声的突然消失佐证。",
  cover:
    "https://readdy.ai/api/search-image?query=Dark%20cinematic%20editorial%20still%20frame%20collage%2C%20layered%20translucent%20video%20timeline%20scrubber%20and%20waveform%20overlay%20on%20moody%20blurred%20interview%20footage%2C%20deep%20crimson%20and%20warm%20amber%20rim%20light%2C%20fine%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20magazine%20cover%20composition%2C%20no%20text%2C%20no%20faces&width=1200&height=720&seq=heivideo-feature-01&orientation=landscape",
  author: "拉片组 · 编辑 A",
  date: "2026-09-11",
  readTime: "12 分钟",
  tags: ["声纹比对", "逐帧复盘", "低频噪声"],
  confidence: "中等置信度",
};

export const latestInsights: InsightItem[] = [
  {
    id: "insight-02",
    title: "片段 A-07 逐帧复盘：灯光跳变暴露的两处剪辑点",
    category: "逐帧画面",
    analysisType: "逐帧复盘",
    summary:
      "单帧亮度曲线在第 18 帧与第 96 帧各出现一次突跳，配合阴影方向变化，可定位两个不连续的镜头接点。",
    cover:
      "https://readdy.ai/api/search-image?query=Frame%20by%20frame%20video%20strip%20contact%20sheet%20laid%20on%20a%20dark%20wood%20table%2C%20magnifier%20over%20a%20single%20frame%2C%20warm%20amber%20and%20crimson%20light%2C%20fine%20film%20grain%2C%20minimal%20editorial%20composition%2C%20no%20text&width=640&height=420&seq=heivideo-card-01&orientation=landscape",
    author: "拉片组 · 编辑 B",
    date: "2026-09-10",
    readTime: "8 分钟",
    tags: ["逐帧复盘", "剪辑点识别", "光源与阴影"],
    confidence: "高置信度",
  },
  {
    id: "insight-03",
    title: "背景广告牌反光里的城市方位推演",
    category: "背景信息",
    analysisType: "背景取证",
    summary:
      "利用玻璃反光中出现的中文字体残缺笔画与广告牌配色，结合日照角度，缩窄到两条可能的街区。",
    cover:
      "https://readdy.ai/api/search-image?query=Night%20city%20street%20reflection%20on%20glass%20window%20with%20warm%20billboard%20glow%2C%20amber%20and%20crimson%20tones%2C%20cinematic%20bokeh%2C%20fine%20film%20grain%2C%20moody%20editorial%20composition%2C%20no%20text&width=640&height=420&seq=heivideo-card-02&orientation=landscape",
    author: "拉片组 · 编辑 C",
    date: "2026-09-09",
    readTime: "10 分钟",
    tags: ["背景广告牌", "反光细节", "机位推演"],
    confidence: "待核实",
  },
  {
    id: "insight-04",
    title: "同一天三段素材的天气与阴影时间线核对",
    category: "时间线",
    analysisType: "时间线重建",
    summary:
      "三段素材的环境光色温基准存在差异，逐帧读取阴影长度后，与当日日照表交叉比对，其中一段时间存在偏移。",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20analog%20clock%20and%20shadow%20study%20on%20a%20dark%20wall%2C%20warm%20amber%20light%20streak%2C%20fine%20film%20grain%2C%20minimal%20editorial%20composition%2C%20no%20text&width=640&height=420&seq=heivideo-card-03&orientation=landscape",
    author: "拉片组 · 编辑 A",
    date: "2026-09-08",
    readTime: "7 分钟",
    tags: ["时间线重建", "天气核对", "光源与阴影"],
    confidence: "中等置信度",
  },
  {
    id: "insight-05",
    title: "直播回放里的瓦数噪声：原始收音还是后期补齐",
    category: "声音识别",
    analysisType: "声纹比对",
    summary:
      "分离出 50Hz 与 100Hz 两条低频基线后，发现争议段落中一条基线在剪辑点前后相位不连续，倾向为后期拼接。",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20an%20audio%20spectrogram%20printed%20on%20paper%20with%20pen%20markings%20on%20a%20dark%20desk%2C%20warm%20amber%20desk%20lamp%20light%2C%20fine%20film%20grain%2C%20editorial%20minimal%20composition%2C%20no%20text&width=640&height=420&seq=heivideo-card-04&orientation=landscape",
    author: "拉片组 · 编辑 D",
    date: "2026-09-07",
    readTime: "9 分钟",
    tags: ["低频噪声", "声纹比对", "直播回放"],
    confidence: "中等置信度",
  },
  {
    id: "insight-06",
    title: "门把手反射画面里出现的第四个人影",
    category: "背景信息",
    analysisType: "背景取证",
    summary:
      "在金属门把手的高光区域恢复出一个人形轮廓，与现场口述的在场人数不符，已列入待核实观察项。",
    cover:
      "https://readdy.ai/api/search-image?query=Door%20handle%20reflection%20detail%20in%20a%20dim%20hallway%2C%20crimson%20and%20amber%20light%2C%20cinematic%20shallow%20depth%20of%20field%2C%20fine%20film%20grain%2C%20editorial%20moody%20composition%2C%20no%20text&width=640&height=420&seq=heivideo-card-05&orientation=landscape",
    author: "拉片组 · 编辑 B",
    date: "2026-09-06",
    readTime: "6 分钟",
    tags: ["反光细节", "背景广告牌", "逐帧复盘"],
    confidence: "待核实",
  },
  {
    id: "insight-07",
    title: "字幕与口型偏移 0.3 秒的来源梳理",
    category: "逐帧画面",
    analysisType: "逐帧复盘",
    summary:
      "把字幕轨与画面轨对齐后发现系统性偏移，判断来源是转码帧率与字幕预设不同步，而非人为改写。",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20condenser%20microphone%20silhouette%20on%20a%20dark%20studio%20desk%20with%20warm%20amber%20accent%20light%2C%20fine%20film%20grain%2C%20minimal%20editorial%20composition%2C%20no%20text&width=640&height=420&seq=heivideo-card-06&orientation=landscape",
    author: "拉片组 · 编辑 C",
    date: "2026-09-05",
    readTime: "5 分钟",
    tags: ["字幕校准", "逐帧复盘", "声纹比对"],
    confidence: "高置信度",
  },
];

export const trendingList = [
  { id: "t-1", rank: "01", title: "三处声纹错位的完整时间码清单", heat: "8.6k" },
  { id: "t-2", rank: "02", title: "广告牌反光还原的街区缩窄过程", heat: "7.2k" },
  { id: "t-3", rank: "03", title: "剪辑点识别的六种常见痕迹", heat: "6.8k" },
  { id: "t-4", rank: "04", title: "低频噪声相位不连续实例讲解", heat: "5.4k" },
  { id: "t-5", rank: "05", title: "逐帧亮度曲线怎样读才不误判", heat: "4.9k" },
];

export type DimensionItem = {
  id: string;
  icon: string;
  name: string;
  count: string;
  desc: string;
};

export const dimensions: DimensionItem[] = [
  {
    id: "dim-1",
    icon: "ri-film-line",
    name: "逐帧画面",
    count: "6.2 万帧",
    desc: "按单帧放大查看构图、光影与物体位移，把可疑变化定位到具体时间码。",
  },
  {
    id: "dim-2",
    icon: "ri-mic-line",
    name: "声音识别",
    count: "1,940 段",
    desc: "分离人声与环境层，比对声纹连续性、低频基线与噪声底噪的变化。",
  },
  {
    id: "dim-3",
    icon: "ri-map-pin-2-line",
    name: "背景信息",
    count: "738 项",
    desc: "从反光、广告牌、招牌字形与建筑风格反推环境，形成可复核的背景线索。",
  },
  {
    id: "dim-4",
    icon: "ri-time-line",
    name: "时间线重建",
    count: "412 组",
    desc: "结合日照角度、阴影长度与设备时间戳，核对素材之间的先后关系。",
  },
  {
    id: "dim-5",
    icon: "ri-lightbulb-line",
    name: "光源与阴影",
    count: "905 处",
    desc: "记录每段素材的主光方向与色温基准，用于判断是否同一场景连续拍摄。",
  },
  {
    id: "dim-6",
    icon: "ri-scissors-cut-line",
    name: "剪辑痕迹",
    count: "1,126 处",
    desc: "识别亮度跳变、运动模糊断裂与音频相位错位等常见后期拼接信号。",
  },
];

export const topicTags = [
  { id: "tag-1", label: "逐帧复盘", count: 214 },
  { id: "tag-2", label: "声纹比对", count: 188 },
  { id: "tag-3", label: "时间线重建", count: 156 },
  { id: "tag-4", label: "背景广告牌", count: 132 },
  { id: "tag-5", label: "反光细节", count: 121 },
  { id: "tag-6", label: "剪辑点识别", count: 118 },
  { id: "tag-7", label: "直播回放", count: 104 },
  { id: "tag-8", label: "天气核对", count: 96 },
  { id: "tag-9", label: "机位推演", count: 88 },
  { id: "tag-10", label: "字幕校准", count: 76 },
  { id: "tag-11", label: "低频噪声", count: 71 },
  { id: "tag-12", label: "陀螺仪数据", count: 63 },
  { id: "tag-13", label: "色温基准", count: 58 },
  { id: "tag-14", label: "阴影长度", count: 52 },
  { id: "tag-15", label: "器材指纹", count: 47 },
  { id: "tag-16", label: "素材登记", count: 44 },
];

export type SuspicionItem = {
  id: string;
  code: string;
  level: "待核实" | "中等置信度" | "高置信度";
  type: string;
  title: string;
  detail: string;
  timecode: string;
};

export const suspicions: SuspicionItem[] = [
  {
    id: "s-1",
    code: "S-2301",
    level: "待核实",
    type: "背景信息",
    title: "现场口述人数与反光轮廓数量不一致",
    detail: "门把手高光区域恢复出的轮廓数量比口述多出一人，尚缺同一时段的第二个机位佐证。",
    timecode: "00:03:12",
  },
  {
    id: "s-2",
    code: "S-2298",
    level: "中等置信度",
    type: "声音识别",
    title: "争议段落环境底噪突然消失 0.8 秒",
    detail: "底噪中断点与画面亮度跳变点接近但不完全重合，需要更多同源素材确认先后。",
    timecode: "00:01:09",
  },
  {
    id: "s-3",
    code: "S-2295",
    level: "待核实",
    type: "时间线",
    title: "背景屏幕时间戳与口述时间相差约 26 分钟",
    detail: "时间戳清晰度偏低，仅能读取小时与分钟的高位数字，结论保留为观察项。",
    timecode: "00:02:47",
  },
  {
    id: "s-4",
    code: "S-2290",
    level: "高置信度",
    type: "剪辑痕迹",
    title: "关键 12 秒内存在两处不易察觉的跳切",
    detail: "亮度曲线与运动模糊断裂点一致，两处跳切在放大到单帧后可稳定复现。",
    timecode: "00:00:42",
  },
  {
    id: "s-5",
    code: "S-2286",
    level: "中等置信度",
    type: "逐帧画面",
    title: "同一设备拍摄的三段素材色温基准存在差异",
    detail: "差异幅度超出自动白平衡的常见波动区间，可能与不同拍摄时段或后期调整有关。",
    timecode: "00:05:31",
  },
];

export const methodSteps = [
  { id: "m-1", step: "01", name: "取材登记", desc: "记录素材来源、设备信息与到手时间，建立可追溯的编号。" },
  { id: "m-2", step: "02", name: "逐帧标注", desc: "把画面拆到单帧，标出构图、光影与物体位移的变化点。" },
  { id: "m-3", step: "03", name: "声音分离", desc: "将人声、环境与低频基线分层，比对连续性与相位。" },
  { id: "m-4", step: "04", name: "背景取证", desc: "从反光、招牌与环境特征反推地点与时间线索。" },
  { id: "m-5", step: "05", name: "交叉复核", desc: "至少两个独立维度吻合才升级为较高置信度结论。" },
  { id: "m-6", step: "06", name: "结论标注", desc: "每条观察点附带时间码与置信度，方便他人自行核对。" },
];

export const trustPoints = [
  { id: "tr-1", icon: "ri-eye-line", title: "观察点可复核", desc: "每条线索都标注时间码，任何人都能回到原片核对。" },
  { id: "tr-2", icon: "ri-bar-chart-2-line", title: "置信度透明", desc: "结论分三级标注，不把待核实项包装成定论。" },
  { id: "tr-3", icon: "ri-refresh-line", title: "修订留痕", desc: "更正内容单独标注修订时间，保留前后差异。" },
];

export const faqs = [
  {
    id: "faq-1",
    q: "页面上的分析结论是最终判断吗？",
    a: "不是。我们只标注可复核的观察点与置信度，不替代任何机构的正式认定，也不对当事人作定性表达。",
  },
  {
    id: "faq-2",
    q: "「疑点」和「结论」有什么区别？",
    a: "疑点是待核实的观察项，往往只有单一维度支撑；结论是在至少两个维度交叉吻合后给出的倾向性说明，两者在页面上分开标注。",
  },
  {
    id: "faq-3",
    q: "逐帧分析为什么强调时间码？",
    a: "很多剪辑痕迹只在单帧里出现，逐帧浏览才能把变化定位到具体时间码，其他人照着时间码就能复现同样的观察。",
  },
  {
    id: "faq-4",
    q: "声音识别会处理原始音轨吗？",
    a: "我们会做声纹与噪声分离，用于比对争议段落是否连续，不对外提供原始音轨，也不保存可识别个人的声纹样本。",
  },
  {
    id: "faq-5",
    q: "发现自己的素材被收录怎么办？",
    a: "可以按页面底部的说明提交补充材料，我们会在核实后追加说明或更正相关内容，并标注修订时间。",
  },
  {
    id: "faq-6",
    q: "更新频率是怎样的？",
    a: "通常按素材登记顺序推进，重大更正会单独成条并标注修订时间，方便对照旧版本阅读。",
  },
];